import { useNavigate } from "react-router-dom"

import { ThemeProvider } from "@mui/material"

import { customTheme, MetricGoalsHeaderMid, MetricHeaderLeft } from "./Atom"
import { useDispatch } from "react-redux"
import { HeaderInfoNav } from "../Reusable"
import { MetricHeaderWrapper } from "../Atom"
import {
  setPNLClasses,
  setPnlReportingMonths,
  setPnlReportingSelectedClasses,
  setSelectedYear,
} from "../../../redux/slices/pnlReportingSlice"
import PnlSelectDropdown from "../../Dropdown/PnlReportingMultiSelectDropdown"
import { useAppSelector } from "../../../redux/hooks"
import { tableTypes } from "../../../pages/PnlReporting/constants"
import SingleSelectFilter from "../../Dropdown/Filters/Index"
import { setMaevaSelectedGroupsNoAll } from "../../../redux/slices/metricSlice"

export default function PnlReportingHeader({ name }: any) {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const handleClickBack = (e: any) => {
    navigate(-1)
  }

  const state = useAppSelector((state) => state.pnlReporting)
  const { tableType, years } = state
  const filterState: any = useAppSelector((store) => store.metric)
  const { maevaSelectedGroupsNoAll, maevaGroups } = filterState
  const loading = useAppSelector((store) => store.app.loading)

  const groupChangeHandler = (_: any, value: any) => {
    dispatch(setMaevaSelectedGroupsNoAll([value?.props?.value]))
    dispatch(setSelectedYear(null))
    dispatch(setPnlReportingMonths([]))
    dispatch(setPNLClasses([]))
    dispatch(setPnlReportingSelectedClasses(null))
  }
  const yearChangeHandler = (_: any, value: any) => {
    dispatch(setSelectedYear(value?.props?.value))
    dispatch(setPnlReportingMonths([]))
    dispatch(setPnlReportingSelectedClasses(null))
  }

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <MetricHeaderWrapper sx={{ pt: 3.5, mb: 1 }}>
          <MetricHeaderLeft>
            <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
          </MetricHeaderLeft>

          <MetricGoalsHeaderMid sx={{ mx: "auto", gap: "10px" }}>
            <SingleSelectFilter
              key={"reporting-1"}
              disabled={tableType !== tableTypes.REPORTING || loading}
              changeHandler={groupChangeHandler}
              placeHolder={"Select a group"}
              selectedValue={maevaSelectedGroupsNoAll?.[0]}
              filterData={maevaGroups}
              filterLabel={"Group Name"}
            />
            <SingleSelectFilter
              key={"reporting-2"}
              disabled={
                tableType !== tableTypes.REPORTING ||
                loading ||
                (maevaSelectedGroupsNoAll?.[0] ? false : true)
              }
              changeHandler={yearChangeHandler}
              placeHolder={"Select a year"}
              selectedValue={years?.selected}
              filterData={years?.data}
              filterLabel={"Year"}
            />
            <PnlSelectDropdown
              disabled={
                tableType !== tableTypes.REPORTING ||
                loading ||
                (years.selected ? false : true)
              }
            />
          </MetricGoalsHeaderMid>
        </MetricHeaderWrapper>
      </ThemeProvider>
    </>
  )
}
